import Page from '@/components/page/Page';
import { StatsOverview } from './components/StatsOverview';
import { ProductInventory } from './components/ProductInventory';
import { AIProcurementAgents } from './components/AIProcurementAgents';
import { TopSuppliers } from './components/TopSuppliers';
import { SalesForecastCard } from './components/SalesForecastCard';
import { InventoryAlertsCard } from './components/InventoryAlertsCard';
import { RecommendationsCard } from './components/RecommendationsCard';

export function ProcurementDemoDashboard() {
  return (
    <Page
      title="Procurement Dashboard"
      subtitle="AI-powered procurement and inventory management"
    >
      <div className="space-y-6">
        {/* Stats Overview - 4 cards at top */}
        <StatsOverview />

        {/* AI Procurement Agents Panel */}
        {/* <AIProcurementAgents /> */}

        {/* Product Inventory and Top Suppliers */}
        <div className="grid gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <ProductInventory />
          </div>
          <div>
            <TopSuppliers />
          </div>
        </div>

        {/* Main Dashboard Grid */}
        <div className="grid gap-6 lg:grid-cols-2">
          {/* Left Column */}
          <div className="space-y-6">
            <SalesForecastCard />
            <InventoryAlertsCard />
          </div>

          {/* Right Column */}
          {/* <div className="space-y-6">
            <RecommendationsCard />
          </div> */}
        </div>
      </div>
    </Page>
  );
}
